import {
  SIGNIN_USER_SUCCESS,
  SIGNUP_USER_SUCCESS,
  REGISTER_MODAL,
  LOGIN_MODAL,
  SUCCESS_MODAL,
} from "../constants";

export function signInUser() {
  return {
    type: SIGNIN_USER_SUCCESS,
  };
}

export function signUpUser() {
  return {
    type: SIGNUP_USER_SUCCESS,
  };
}

export function loginModal() {
  return {
    type: LOGIN_MODAL,
  };
}

export function registerModal() {
  return {
    type: REGISTER_MODAL,
  };
}
  
export function successModal() {
  return {
    type: SUCCESS_MODAL,
  };
}
